export default __webpack_public_path__ + "static/bomb-arrows-2f0354376c69422403961ba2bba0c7fd.png";